import React from 'react';
import CallLogo from "../../assets/images/logo/phone-call.png";
import WhatsappLogo from "../../assets/images/logo/social.png"

const FloatingButtons = () => {
  const containerStyle = {
    position: 'fixed',
    bottom: '60px',
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    zIndex: 9,
  };

  const iconStyle = {
    width: '50px',
    height: '50px',
    objectFit: 'contain',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      {/* <a href="tel:+9344481444">
        <img
          src={CallLogo}
          alt="Call"
          style={iconStyle}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        />
      </a> */}
      {/* <a
        href="https://wa.me/9344481444"
        target="_blank"
        rel="noopener noreferrer"
      > */}
        {/* <img
          src={WhatsappLogo}
          alt="WhatsApp"
          style={iconStyle}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        />
      </a> */}
    </div>
  );
};

export default FloatingButtons;
